/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {StateService} from '@uirouter/core';

@Component({
  standalone: false,
  selector: 'adn-list-default-actions',
  template: `
    <a *ngIf="!readOnly"
       name="adnListNew"
       class="btn btn-default btn-xs"
       [attr.href]="newHref"
       (click)="goToNew($event)">
      <span class="fa fa-fw fa-plus-circle"></span>
      <span>{{ 'button.add.new' | ogTranslate }}</span>
    </a>
  `
})
export class ListDefaultActionsComponent {
  @Input() readOnly: boolean;
  /** Optional override when list state is not the current state. */
  @Input() newStateName: string;

  constructor(private readonly $state: StateService) {
  }

  get newHref(): string {
    return this.$state.href(this.resolveNewStateName(), null, {inherit: false}) || '';
  }

  goToNew(event: Event): void {
    event.preventDefault();
    this.$state.go(this.resolveNewStateName());
  }

  private resolveNewStateName(): string {
    if (this.newStateName) {
      return this.newStateName;
    }
    // Hard-code from current list state — relative uiSref like ".new" has no
    // reference point in context components.
    return this.$state.current.name + '.new';
  }

}
